import React, { ReactNode } from 'react';
import { Box } from "@mui/material";

interface MyContainerProps {
    id?: string;
    children: ReactNode;
    className?: string;
}

const MyContainer = (props: MyContainerProps) => {
    return (
        <Box
            id={props.id}
            className={props.className}
            sx={{ maxWidth: "1640px", margin: "0 auto", padding: { xs: "48px 4%", md: "80px 4%", xl: "112px 4%" } }}
        >
            {props.children}
        </Box>
    );
};

export default MyContainer;
